"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaxLinesComponent = void 0;
var max_lines_component_1 = require("./max-lines-component");
Object.defineProperty(exports, "MaxLinesComponent", { enumerable: true, get: function () { return max_lines_component_1.MaxLinesComponent; } });
